import classNames from 'clsx';
import * as React from 'react';
import { BannerWrapper } from 'shared/map-search/components/BannerWrapper';

import * as styles from './styles.css';

export interface IDesktopSpecialProjectTemplateProps {
  title: React.ReactNode;
  description: React.ReactNode;
  copyright: React.ReactNode;
  onClick?(): void;
  onClose?(event: React.MouseEvent<HTMLElement>): void;
  url: string;
  isSearchResultsOpen?: boolean;
  rootClassName?: string;
  image?: string;
  logoImageUrl: string;
}

export function DesktopSpecialProjectTemplate({
  title,
  description,
  copyright,
  onClick,
  onClose,
  url,
  rootClassName,
  isSearchResultsOpen,
  image,
  logoImageUrl,
}: IDesktopSpecialProjectTemplateProps) {
  return (
    <BannerWrapper
      moveRight={isSearchResultsOpen}
      attributes={{
        className: classNames(rootClassName),
      }}
    >
      <button className={styles['close']} onClick={onClose} />

      <div data-testid="special-project-banner-background" className={styles['image-container']}>
        {image && <div className={styles['image']} style={{ backgroundImage: `url(${image})` }} />}
      </div>

      <a href={url} target="_blank" rel="noopener noreferrer" className={styles['content']} onClick={onClick}>
        <div className={styles['info']}>
          <div data-testid="special-project-banner-title">{title}</div>
          <div data-testid="special-project-banner-description">{description}</div>
        </div>

        <div data-testid="special-project-banner-logo" className={styles['logo']}>
          <img src={logoImageUrl} alt="" />
        </div>
      </a>

      <div data-testid="special-project-banner-copyright" className={styles['copyright']}>
        {copyright}
      </div>
    </BannerWrapper>
  );
}
